export default vue => ({
  dataSource: [
    {
      id: 'new',
      name: vue.$t('new'),
    },
    {
      id: 'pending',
      name: vue.$t('pending'),
    },
    {
      id: 'approved',
      name: vue.$t('approved'),
    },
    {
      id: 'declined',
      name: vue.$t('declined'),
    },
  ],
  valueExpr: 'id',
  displayExpr: 'name',
});
